import React from "react";

const MutedInformationPanel = ({information, className}:{information: any, className?: string}) => {

    if (!information) {
        return <></>
    }
    return (
        <div className={`muted-information-panel ${className ?? ""}`} >
            <span className="muted-information-message">{information}</span>
        </div>
    );
};

export default MutedInformationPanel